import { render, staticRenderFns } from "./OpenHatch.vue?vue&type=template&id=0fc30798&"
import script from "./OpenHatch.vue?vue&type=script&lang=js&"
export * from "./OpenHatch.vue?vue&type=script&lang=js&"
import style0 from "./OpenHatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports